import { render, staticRenderFns } from "./AudioTranscribe.vue?vue&type=template&id=54953194&scoped=true"
import script from "./AudioTranscribe.vue?vue&type=script&lang=js"
export * from "./AudioTranscribe.vue?vue&type=script&lang=js"
import style0 from "./AudioTranscribe.vue?vue&type=style&index=0&id=54953194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54953194",
  null
  
)

export default component.exports